
/*
|--------------------------------------------------------------------------
| Partials
|--------------------------------------------------------------------------
|
| Split the application code to several files. Almost all of the following
| files are required for the application to work properly.
|
*/
require('../partials/config.js');
require('../partials/bind.js');
require('../partials/drawer.js');
require('../partials/font.js');
require('../partials/form.js');
require('../partials/mailer.js');
require('../partials/map.js');
require('../partials/modal.js');
require('../partials/navbar.js');
require('../partials/offcanvas.js');
require('../partials/popup.js');
require('../partials/recaptcha.js');
require('../partials/scroll.js');
require('../partials/section.js');
require('../partials/sidebar.js');
require('../partials/video.js');
require('../partials/util.js');
